import {
  BLOG_LIST_LOADING,
  GET_BLOG_LIST,
  GET_BLOG_LIST_ERROR,
  GET_BLOG_BY_ID_LOADING,
  GET_BLOG_BY_ID_SUCCESS,
  GET_BLOG_BY_ID_ERROR,
  DELETEING_BLOG,
  DELETE_BLOG,
  DELETE_BLOG_ERROR,
  DELETED_BLOG_LIST_LOADING,
  GET_DELETED_BLOG_LIST,
  GET_DELETED_BLOG_LIST_ERROR,
  RESTORE_BLOG_LIST_LOADING,
  RESTORE_BLOG_LIST,
  RESTORE_BLOG_LIST_ERROR,   
  PERMA_DELETE_BLOG,
  PERMA_DELETE_BLOG_ERROR,
  PERMA_DELETEING_BLOG,
  
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: BLOG_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_BLOG_LIST,
        payload: response,
      })
    })
    .catch(function (error) {
      dispatch({
        type: GET_BLOG_LIST_ERROR,
        payload: error.response,
      })      
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_BLOG_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_BLOG_BY_ID_SUCCESS,
        payload: response,
      })      
    })
    .catch(function (error) {
      dispatch({
        type: GET_BLOG_BY_ID_ERROR,
        payload: error.response,
      })      
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_BLOG_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_BLOG_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_BLOG_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_BLOG,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_BLOG,
        payload: response,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_BLOG_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_BLOG,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_BLOG,
        payload: response,
      })      
      message.success(response.data.message)
    })
    .catch(function (error) {
      console.log('error:::::::', error);
      dispatch({
        type: PERMA_DELETE_BLOG_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList, history) => async (dispatch) => {
  dispatch({
    type: RESTORE_BLOG_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_BLOG_LIST,
        payload: response,
      });
        history.push("/blogs")        
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_BLOG_LIST_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};



